export const isChecked = (contributor) => {
  const contributorCheck = Object.values(contributor).some((e) => e === "");
  return contributorCheck;
};
